module.exports = __webpack_public_path__ + "static/media/homepage_grid_1.dc94dd0d.jpg";